import React, { useState } from 'react';

const TeachingTip = ({ 
  text, 
  initialExpanded = false, 
  loading = false,
  error = null
}) => {
  const [expanded, setExpanded] = useState(initialExpanded);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  if (loading) {
    return <div className="teaching-tip-loading">Loading...</div>;
  }

  if (error) {
    return <div className="teaching-tip-error">Error: {error}</div>;
  }

  if (!text) {
    return null;
  }

  return (
    <div className="teaching-tip-container">
      <div 
        onClick={toggleExpanded} 
        className={`teaching-tip-toggle ${expanded ? 'expanded' : ''}`}
      >
        <div className="teaching-tip-toggle-content">
          <span className="teaching-tip-icon">📘</span>
          <span className="teaching-tip-text">{expanded ? 'Hide Teaching Tip' : 'Show Teaching Tip'}</span>
          <span className="teaching-tip-arrow">{expanded ? '▲' : '▼'}</span>
        </div>
      </div>
      {expanded && (
        <div className="teaching-tip-content">
          {text}
        </div>
      )}
    </div>
  );
};

export default TeachingTip;